(function () {
  function setupColorFallback(radios) {
    const colorFieldset = Array.from(radios.querySelectorAll('fieldset.color-variant')).find(
      function (fieldset) {
        return !fieldset.closest('.variants-placeholder');
      }
    );
    if (!colorFieldset || colorFieldset.dataset.colorFallbackEnabled === 'true') return;

    const root = radios.closest('[x-data="variants"]');
    if (!root) return;

    const component = window.Alpine.$data(root);
    if (!component || !component.data || !component.data.options_with_values) return;
    if (component.data.options_with_values.length < 2) return;

    const colorOption = component.data.options_with_values.find(function (option) {
      return option.name.toLowerCase().indexOf('color') !== -1;
    });
    if (!colorOption) return;

    const colorIndex = colorOption.position - 1;

    colorFieldset.dataset.colorFallbackEnabled = 'true';

    colorFieldset.addEventListener(
      'click',
      function (event) {
        const label = event.target.closest('label[data-disabled="true"]');
        if (!label) return;

        const wrapper = label.closest('[data-variant-title]');
        const colorValue = wrapper && wrapper.dataset.variantTitle;
        if (!colorValue) return;

        const fallback = component.data.variants.find(function (variant) {
          return variant.available && variant.options[colorIndex] === colorValue;
        });
        if (!fallback) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        component.data.selected = fallback;
        component._updateHash();
        component._updateVariantStatuses();
      },
      true
    );
  }

  function init() {
    if (!window.Alpine) return;
    document.querySelectorAll('aw-variant-radios').forEach(setupColorFallback);
  }

  if (window.Alpine) init();

  document.addEventListener('alpine:initialized', function () {
    setTimeout(init, 0);
  });
})();